import React, { useState } from "react";
import "./FreeQuote.scss";
import money from "./money.png";
import illustration from "./illustration.svg";
import illustration2 from "./illustration2.svg";
import { translateString } from "../../../helpers/translator";

export default function FreeQuote({language}) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [projectType, setProjectType] = useState("");
  const [description, setDescription] = useState("");

  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handlePostMessage = async (e) => {
    e.preventDefault();
    setHasError(false);
    setHasSubmitted(false);

    if (!name || !email) {
      return false;
    }

    try {
      await fetch("https://api.centralfeedback.com/api/v1/responses/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          formId: "66",
          answers: {
            "Your Name": name,
            "Company Name / Website": company,
            "Project Type": projectType,
            "Describe What You Need": description,
            "Where can we reach you?": email,
          },
        }),
      });
      setHasSubmitted(true);
    } catch (e) {
      setHasError(true);
    }
  };

  return (
    <section className="free-quote" id="quote">
      <img
        src={illustration}
        alt=""
        className="free-quote__topcorner-illustration"
      />
      <img
        src={illustration2}
        alt=""
        className="free-quote__bottomcorner-illustration"
      />

      <div className="container">
        <div className="row">
          <div className="col-lg-4"></div>
          <div className="col-lg-4">
            <div className="image">
              <img src={money} alt="sal" />
            </div>

            <h2 className="title">{translateString("HOME.FREEQUOTE.header_1", language)}</h2>
            <p className="description">
              {translateString("HOME.FREEQUOTE.p_1", language)}  
            </p>
            <p className="announcement">
              {translateString("HOME.FREEQUOTE.p_2", language)} 
            </p>
          </div>
          <div className="col-lg-4"></div>
        </div>

        <div className="row">
          <div className="col-lg-2"></div>
          <div className="col-lg-8">
            <div className="forms">
              <form>
                <div className="first-two">
                  <div className="form-box">
                    <label class="form-label">{translateString("HOME.FREEQUOTE.formYourName", language)}</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder={translateString("HOME.FREEQUOTE.formYourNamePlaceholder", language)}
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    ></input>
                  </div>
                  <div className="form-box">
                    <label class="form-label">{translateString("HOME.FREEQUOTE.formCompanyName", language)}</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder={translateString("HOME.FREEQUOTE.formCompanyNamePlaceholder", language)}
                      value={company}
                      onChange={(e) => setCompany(e.target.value)}
                    ></input>
                  </div>
                </div>

                <div className="first-two">
                  <div className="form-box">
                    <label class="form-label">{translateString("HOME.FREEQUOTE.formYourEmail", language)}</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder={translateString("HOME.FREEQUOTE.formYourEmailPlaceholder", language)}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    ></input>
                  </div>
                  <div className="form-box">
                    <label for="type" class="form-label">
                    {translateString("HOME.FREEQUOTE.formProjectType", language)}
                    </label>
                    <select
                      className="form-control"
                      id="type"
                      value={projectType}
                      onChange={(e) => setProjectType(e.target.value)}
                    >
                      <option value="Select an option">{translateString("HOME.FREEQUOTE.formProjectType_1", language)}</option>
                      <option value="website">{translateString("HOME.FREEQUOTE.formProjectType_2", language)}</option>
                      <option value="web-app">{translateString("HOME.FREEQUOTE.formProjectType_3", language)}</option>
                      <option value="mobile-app">{translateString("HOME.FREEQUOTE.formProjectType_4", language)}</option>
                      <option value="design">{translateString("HOME.FREEQUOTE.formProjectType_5", language)}</option>
                      <option value="development">{translateString("HOME.FREEQUOTE.formProjectType_6", language)}</option>
                      <option value="consultancy">{translateString("HOME.FREEQUOTE.formProjectType_7", language)}</option>
                      <option value="other">{translateString("HOME.FREEQUOTE.formProjectType_8", language)}</option>
                    </select>
                  </div>
                </div>
                <div className="form-box" id="thirdbox">
                  <label for="name" class="form-label">
                  {translateString("HOME.FREEQUOTE.formDescription", language)}
                  </label>
                  <textarea
                    id="text-area"
                    rows="2"
                    placeholder={translateString("HOME.FREEQUOTE.formDescriptionPlaceholder", language)}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  ></textarea>
                </div>

                <button onClick={handlePostMessage}>{translateString("HOME.FREEQUOTE.formSubmit", language)}</button>

                {hasSubmitted && (
                  <p className="alert alert-success mt-3">
                    {translateString("HOME.FREEQUOTE.formSubmitSucces", language)}
                  </p>
                )}
                {hasError && (
                  <p className="alert alert-danger mt-3">
                    {translateString("HOME.FREEQUOTE.formSubmitError", language)}
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
